import { Attributes, Misc, NeoModel, Rules, Validation, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class ManuallyCreatedTransactionLookup extends ValueObject {
    public rawImportFileID: number = 0;

    @Rules.Required()
    @Attributes.Display("Broker")
    public staticServiceProviderFileGroupingID: number = 0;

    public serviceProviderGroupingName: string = "";

    public isCashInd: boolean = false;

    public staticInstrumentID: number = 0;

    public staticEventID: number = 0;

    public accountCurrencyID: number = 0;

    public instrumentCurrencyID: number = 0;

    @Rules.StringLength(20)
    public securityCode: string = "";

    @Rules.StringLength(100)
    public securityDescription: string = "";

    @Rules.StringLength(20)
    public ISIN: string = "";

    public instrumentType: string = "";

    public instrumentSubType: string = "";

    public exchangeID: number = 0;

    public clientAccountID: number = 0;

    public exchangeName: string = "";

    public exchangeMIC: string = "";

    @Rules.Required()
    public eventType: string = "";

    public corporateActionType: string = "";

    @Rules.StringLength(100)
    public adHocBookingType: string = "";

    public buyOrSell: string = "";

    @Rules.Required()
    @Attributes.Display("Event ID")
    public eventID: string = "";

    @Rules.Required()
    @Rules.StringLength(100)
    public rawAccountID: string = "";

    @Attributes.Date(Misc.TimeZoneFormat.None)
    @Rules.Required()
    @Attributes.Display("Transaction Date")
    public dateTimeEvent: Date | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    @Rules.Required()
    public dateValue: Date | null = null;

    @Rules.Required()
    public instrumentCurrencyCode: string = "";

    @Rules.Required()
    public accountCurrencyCode: string = "";

    @Attributes.Float()
    public transactionQuantity: number = 0;

    @Attributes.Float()
    public transactionAmount: number = 0;

    public isReversal: boolean = false;

    @Rules.StringLength(100)
    public eventIDRelated: string | null = null;

    @Rules.StringLength(200)
    public comment: string | null = null;

    public firstName: string | undefined = "";

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        rules.failWhen(r => r.isReversal && (r.eventIDRelated === undefined || r.eventIDRelated === null), "Please specify the related transaction ID for a reversal.");
        rules.failWhen(t => t.transactionAmount * t.transactionQuantity < 0, "Transaction quantity and transaction amount must have the same sign.");
        rules.failWhen(c => !c.isCashInd && (c.securityCode === undefined || c.securityCode === null), "Please specify the instrument for security transactions.");
    }

}